module.exports = __webpack_public_path__ + "static/karine-9498b9be7508a3a2edbdf93bf591e94e.jpg";